import script from "./DevicesMap.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesMap.vue?vue&type=script&setup=true&lang=js"

import "./DevicesMap.vue?vue&type=style&index=0&id=1071bf81&lang=css"

const __exports__ = script;

export default __exports__